// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__H_YAX","inputWrap":"Table_inputWrap__3Ls1o","col":"Table_col__13-YZ","bmiTooltip":"Table_bmiTooltip__1-fJ9"};